var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShImage',{attrs:{"srcset":_vm.srcset,"alt":_vm.imageAlt,"loading":_vm.loadingImage,"round":_vm.round,"aspect-ratio":_vm.aspectRatio}})}
var staticRenderFns = []

export { render, staticRenderFns }